import React, { FC, useState } from 'react'
import { RelationshipForm } from '../RelationshipForm'
import { Option } from 'helpers/selects'
import { CButton } from 'tabs/data/components/CButton'
import Modal from '@material-ui/core/Modal'
import * as S from './NewDatasetRelation.style'
import { Column } from '../../../../../api/generated'
import { RelationshipsRequest } from '../relationships.types'

type NewDatasetRelationProps = {
  options: Option[]
  onSubmit: (request: RelationshipsRequest) => Promise<void>
  columns: Map<string, Column[]>
}

export const NewDatasetRelation: FC<NewDatasetRelationProps> = ({ options, onSubmit, columns }) => {
  const [open, setOpen] = useState(false)

  const resetForm = () => {
    setOpen(false)
  }

  const handleCreateRelation = async (request: RelationshipsRequest) => {
    await onSubmit(request)
    resetForm()
  }

  return (
    <>
      <CButton label="+ Add Relationship" color="primary" onClick={() => setOpen(true)} />

      <Modal open={open}>
        <S.Container>
          <S.Title>New Relationship</S.Title>

          <RelationshipForm
            sourceTable=""
            sourceColumn=""
            destinationTable=""
            columns={columns}
            targetColumn=""
            selectMenuPosition="absolute"
            cancelButtonLabel="Cancel"
            submitButtonLabel="Create"
            options={options}
            joinedTables={[]}
            synonyms={[]}
            onSubmit={handleCreateRelation}
            onCancel={resetForm}
          />
        </S.Container>
      </Modal>
    </>
  )
}
